module.exports = __webpack_public_path__ + "img/Vector-1.34874b7d.svg";